import { action, observable } from 'mobx'

export class ClientSearchStore {
  @observable anchorEl = null
  @observable anchorElClient = null

  /**
   * handlePopOverClick
   * Sets anchor element for client search pop over
   */
  @action handlePopOverClick = event => {
    this.anchorEl = event.currentTarget
  }

  /**
   * handlePopOverClose
   * Closes the popover
   */
  @action handlePopOverClose = () => {
    this.anchorEl = null
  }

  @action handlePopoverClientClick = e => {
    this.anchorElClient = e.currentTarget
  }
}

export const clientSearch = new ClientSearchStore()
